import React, { Fragment } from 'react';
import IconButton from 'material-ui/IconButton';
import ContentAddIcon from 'material-ui/svg-icons/content/add-circle-outline';
import ContentRemoveIcon from 'material-ui/svg-icons/content/remove-circle-outline';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui';
import NumberField from '../../../Base/NumberField';

const TOP_LABELS = {
    maxTt: 'Max TT strength by hold',
    maxTween: 'Max Tween strength',
};

const BOTTOM_LABELS = {
    upperDeck: 'Upper deck strength',
    crossDeck: 'Cross deck strength',
    hatchCover: 'Hatch cover strength',
    maxWeather: 'Max Weather Deck strength',
};

/** @type {Record<string, import('react').CSSProperties>} */
const styles = {
    actionsCol: {
        width: '50px',
        paddingLeft: '0',
        paddingRight: '0',
        textAlign: 'center',
    },
    numberCol: {
        width: '40px',
        paddingLeft: '20px',
        paddingRight: '0',
        textAlign: 'left',
    },
};

function StrengthNumerics({ labels, getError, changeField, modifiedFields, underStyle, strength, confirmed }) {
    return (
        <Fragment>
            {Object.entries(labels).map(([field, label]) => (
                <div className='col-xs-6' key={field}>
                    <NumberField
                        disabled={confirmed}
                        name={`strength.${field}`}
                        floatingLabelText={label}
                        value={strength[field] || ''}
                        errorText={getError(`strength.${field}`)}
                        fullWidth
                        floatNumber
                        min={0}
                        onChange={(e, value) => {
                            changeField({
                                field: `strength.${field}`,
                                value,
                                type: 'number'
                            });
                        }}
                        underlineStyle={modifiedFields && modifiedFields.includes(`strength.${field}`) ? underStyle : null}
                    />
                </div>
            ))}
        </Fragment>
    );
}

/** @param {{ getError, changeField, modifiedFields, underStyle, strength, confirmed }} props */
function Strength(props) {
    const { confirmed, getError, modifiedFields, changeField, underStyle } = props;
    let { tanktopByHolds } = props.strength;
    if (!tanktopByHolds) {
        tanktopByHolds = [''];
    }
    const addRow = () => {
        props.changeField({
            field: 'strength.tanktopByHolds',
            value: [...tanktopByHolds, undefined],
        });
    };
    const removeRow = (index) => {
        const slice = tanktopByHolds.slice();
        slice.splice(index, 1);
        props.changeField({
            field: 'strength.tanktopByHolds',
            value: slice,
        });
    };
    return (
        <Fragment>
            <div className='row'>
                <StrengthNumerics labels={TOP_LABELS} {...props} />
            </div>
            <div className='row'>
                <div className='col-xs-6'>
                    <Table selectable={false} style={{ border: '1px solid rgb(223, 223, 223)' }}>
                        <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                            <TableRow>
                                <TableHeaderColumn colSpan={3}>
                                    Tanktop strength by holds
                                </TableHeaderColumn>
                            </TableRow>
                        </TableHeader>
                        <TableBody displayRowCheckbox={false}>
                            {tanktopByHolds.map((strength, index) => (
                                <TableRow key={index}>
                                    <TableRowColumn style={styles.numberCol}>
                                        {index + 1}
                                    </TableRowColumn>
                                    <TableRowColumn>
                                        <NumberField
                                            disabled={confirmed}
                                            name={`strength.tanktopByHolds[${index}]`}
                                            value={strength || ''}
                                            errorText={getError(`strength.tanktopByHolds[${index}]`)}
                                            fullWidth
                                            floatNumber
                                            min={0}
                                            onChange={(e, value) => {
                                                changeField({
                                                    field: `strength.tanktopByHolds[${index}]`,
                                                    value,
                                                    type: 'number'
                                                });
                                            }}
                                            underlineStyle={modifiedFields && modifiedFields.includes(`strength.tanktopByHolds[${index}]`) ? underStyle : null}
                                        />
                                    </TableRowColumn>
                                    <TableRowColumn style={styles.actionsCol}>
                                        {index === 0 && (
                                            <IconButton
                                                disabled={props.confirmed}
                                                onClick={addRow}>
                                                <ContentAddIcon color='green'/>
                                            </IconButton>
                                        )}
                                        {index !== 0 && (
                                            <IconButton onClick={() => removeRow(index)}>
                                                <ContentRemoveIcon color='red' />
                                            </IconButton>
                                        )}
                                    </TableRowColumn>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </div>
            </div>
            <div className='row'>
                <StrengthNumerics labels={BOTTOM_LABELS} {...props} />
            </div>
        </Fragment>
    );
}

export default Strength;



// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Rows/Strength.jsx